import styled from 'styled-components';

export default styled.div`
  &:before {
    width: 100%;
    font-size: 1.3rem;
    content: ${props => `"${props.$header}"`};
    ${props => `color: ${props.$color ? props.$color : '#6D7286' };`}
  }
  min-width: 28rem;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 1rem 0;
  row-gap: 1rem;
`;
